module.exports = __webpack_public_path__ + "kneelcry.5485dd00.png";